<!--
 * @Author: zl
 * @Date: 2022-09-15 15:56:14
 * @LastEditTime: 2022-09-16 17:29:34
 * @LastEditors: zl
 * @Description: 核对纪要
-->
<template>
	<div class='CheckSummary-layout'>
		<el-row>
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">政 府 投 资 建 设 项 目 工 程 协 审 核 对 纪 要</h2>
				<el-descriptions :column="2"
								 size="small"
								 border
								 class="custom-descriptions">
					<el-descriptions-item label="工程项目名称"
										  :span="2">{{ currentObj.proName }}</el-descriptions-item>
					<el-descriptions-item label="关联审计任务"
										  :span="2">{{ form.taskIdName }}</el-descriptions-item>
					<el-descriptions-item label="核对日期">
						{{ form.checkDate ? form.checkDate.substr(0, 10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="核对地点">{{ form.checkAdd }}</el-descriptions-item>
					<el-descriptions-item label="参加人员">{{ form.confereeName }}</el-descriptions-item>
					<el-descriptions-item label="施工单位">{{ form.roadUnitName }}</el-descriptions-item>
					<el-descriptions-item label="审价单位"
										  :span="2">{{ form.appUnit }}</el-descriptions-item>
					<el-descriptions-item label="监理单位"
										  :span="2">{{ form.supUnit }}</el-descriptions-item>
					<el-descriptions-item label="建设单位"
										  :span="2">{{ form.consUnitName }}</el-descriptions-item>
					<el-descriptions-item label="审计组"
										  :span="2">{{ form.auditTeamNames }}</el-descriptions-item>
					<el-descriptions-item label="主要内容"
										  :span="2"
										  contentClassName="h200">
						<div class="quill-editor editor w100">
							<div class="ql-container">
								<div class="ql-editor">
									<div class="content"
										 v-html="form.contents"></div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="签名"
										  :span="2"
										  contentClassName="pd0">
						<el-descriptions :column="2"
										 size="small"
										 style="margin: -2px"
										 border
										 class="custom-descriptions sp-descriptions">
							<el-descriptions-item label="施工单位人员"></el-descriptions-item>
							<el-descriptions-item label="审价单位人员"></el-descriptions-item>
							<el-descriptions-item label="建设单位人员"></el-descriptions-item>
							<el-descriptions-item label="监理单位人员"></el-descriptions-item>
							<el-descriptions-item label="审计组长"></el-descriptions-item>
							<el-descriptions-item label="记录人"></el-descriptions-item>
						</el-descriptions>
					</el-descriptions-item>
					<el-descriptions-item label="上传附件"
										  :span="2">
						<myUpload listType="list"
								  ref="checkUpload"
								  tableName="audit_check_minutes"
								  uploadType="2"
								  assortment="test3"
								  width="auto"
								  height="auto"
								  :aid="form.id"
								  mode="view"
								  class="h100 w100"></myUpload>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.selectCheckMinutesDetail({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
</style>